import React from 'react';
import { TextInput } from '@zapier/design-system';

type PostalCodeInputProps = {
  /** Show Error styling */
  hasError?: boolean;
  /** input id */
  id?: string;
  /** Id of label element */
  labelId?: string;
  /** Call when value is changed */
  onChange: (event: React.ChangeEvent<Element> | string) => void;
  /** Current value */
  value: string;
};

const PostalCodeInput = ({
  hasError = false,
  labelId,
  id,
  onChange,
  value,
}: PostalCodeInputProps) => {
  return (
    <TextInput
      aria-labelledby={labelId}
      autoComplete="shipping postal-code"
      id={id}
      isErrored={hasError}
      maxLength={5}
      name="addressZip"
      onChange={onChange}
      placeholder="00000"
      type="tel"
      value={value}
    />
  );
};

export default PostalCodeInput;
